'use client'

import { Footer } from '@/components/footer'
import { useConfig } from '@/app/hooks'

/**
 * Wires runtime build metadata (app version, deployment region, and build id)
 * from the client config into the presentational Footer, which stays
 * config-agnostic so it remains portable as a shadcn registry block. The
 * build string renders as hidden text in the footer, revealed only on
 * selection — a diagnostic aid. The build id mirrors ui-react's footer:
 * `<build_number>-<git_commit>`.
 */
export const FooterContainer = () => {
    const config = useConfig()

    return (
        <Footer
            region={config.region}
            build={{
                version: config.service.version,
                number: `${config.build.number}-${config.git.commit.short}`,
            }}
        />
    )
}
